import { Component, Input } from '@angular/core';
import { AccountUsageLimitDto } from '../../models/account-usage.model';
import { LanguageService } from '../../../../services/language/language.service';
import { HeroMetricView, buildHeroMetrics } from './usage-key-metric.presenter';

/**
 * HERO presentacional con las 3 metricas clave del plan. Solo presentacion:
 * no llama a la API; recibe los limites del padre (AccountUsageComponent) y
 * selecciona las 3 metricas clave por su limit_code. La fiabilidad de datos
 * (estado 'unavailable'/'missing' -> "Sin datos aun") se resuelve en el
 * presenter, con el mismo criterio que UsageLimitCardComponent.
 */
@Component({
  selector: 'app-usage-key-metrics-hero',
  templateUrl: './usage-key-metrics-hero.component.html',
  styleUrls: ['./usage-key-metrics-hero.component.scss'],
  standalone: false,
})
export class UsageKeyMetricsHeroComponent {
  private _limits: AccountUsageLimitDto[] = [];
  metrics: HeroMetricView[] = buildHeroMetrics([], this.languageService);

  constructor(private readonly languageService: LanguageService) {}

  @Input()
  set limits(value: AccountUsageLimitDto[] | null | undefined) {
    this._limits = value ?? [];
    this.metrics = buildHeroMetrics(this._limits, this.languageService);
  }
  get limits(): AccountUsageLimitDto[] {
    return this._limits;
  }

  trackMetric(_index: number, metric: HeroMetricView): string {
    return metric.limitCode;
  }
}
